/**
 * One small line at the top centre of a `.VEST` chart with the ATR TP / SL +
 * size suggestion (#637), e.g. `ATR 47.0 · SL 70.5 · TP 94.0 · 0.5820 BTC @ $50`.
 * Renders nothing when there is no legend (every non-`.VEST` chart, toggle
 * off, no answer yet). Hover shows the detail.
 */

import React from 'react';
import type { VestSizingLegend as Legend } from '../../utils/vestSizingLines';

export const VestSizingLegend: React.FC<{ legend: Legend | null }> = ({ legend }) => {
  if (!legend) return null;
  return (
    <div
      className={`vest-sizing-legend vest-sizing-legend--${legend.tone}`}
      data-vest-sizing={legend.tone}
      title={legend.detail}
    >
      {legend.text}
    </div>
  );
};
